// Returns the height available for a scrollable table body so it fills the
// space between the headers above it and the bottom of the viewport.
//
// Above the table body sit three headers:
//   1. the top navigation menu    -> #mainMenu
//   2. the page / form header     -> #pageHeader   (title + search + tabs)
//   3. the table's own header row -> #tableHeader
//
// The bottom edge of #tableHeader is exactly where the scroll body starts, and
// using its on-screen position (getBoundingClientRect) automatically accounts
// for the menu, the page header AND every margin/padding between them — so the
// table grows and shrinks correctly on any window resize.
// `bottomGap` leaves a little breathing room below the table.
export const setTableHeight = (setHeight, bottomGap = 16) => {
    const tableHeader = document.getElementById("tableHeader")
    if (tableHeader) {
        const bodyTop = tableHeader.getBoundingClientRect().bottom
        const available = window.innerHeight - bodyTop - bottomGap
        setHeight(available > 150 ? available : 150)
        return
    }
    // Table not mounted yet (e.g. still loading): approximate from the headers
    // that do exist so the first paint is close, then it self-corrects.
    const heightOf = (id) => {
        const el = document.getElementById(id)
        return el ? Math.ceil(el.getBoundingClientRect().height) : 0
    }
    const used = heightOf("mainMenu") + heightOf("pageHeader") + 60
    const available = window.innerHeight - used - bottomGap
    setHeight(available > 150 ? available : 150)
}

export const heightSet = (setHeight) => {

    let menuHeight = document.getElementById("menuContent") ? document.getElementById("menuContent").clientHeight : 0
    let headDiv = document.getElementById("headContent") ? document.getElementById("headContent").clientHeight : 0
    let getHeight = parseFloat(headDiv)
    let windowHeight = window.innerHeight
    let setHeightDiv = parseFloat(windowHeight) - (parseFloat(getHeight) + parseFloat(menuHeight) + 25)
    setHeight(setHeightDiv)
}
export const rowBodyHeightSet = (setInnerHeight) => {

    let menuHeight = document.getElementById("menuContent") ? document.getElementById("menuContent").clientHeight : 0
    let headDiv = document.getElementById("headContent") ? document.getElementById("headContent").clientHeight : 0
    let innerHeadDiv= document.getElementById("headerRowObj") ? document.getElementById("headerRowObj").clientHeight : 0
    let getHeight = parseFloat(headDiv) + parseFloat(innerHeadDiv) + parseFloat(menuHeight) + 10
    let windowHeight = window.innerHeight
    let setHeightDiv = parseFloat(windowHeight) - (parseFloat(getHeight) + 25)
    setInnerHeight(setHeightDiv)
}


